import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import {showConfirmAlert} from 'services/alert'

const ConfirmMutationMenuItem = ({
    useMutation,
    itemId,
    handleClose,
    title,
    Icon,
    translationKey,
    confirmText,
}) => {
    const [doMutation] = useMutation()
    const {t} = useTranslation()

    const onClickHandler = (e) => {
        handleClose?.(e)
        showConfirmAlert({
            e,
            text: confirmText || t(`${translationKey}.confirm`),
            onConfirm: () =>
                toast.promise(
                    doMutation(itemId).unwrap(),
                    {
                        loading: t('loading'),
                        success: () => t(`${translationKey}.success`),
                        error: (err) => err?.data?.error || t(`${translationKey}.error`),
                    }
                ),
            disableSuccessAlert: true,
            t,
        })
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={onClickHandler}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default ConfirmMutationMenuItem
